import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgDisplay03 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay03";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import PrimaryBtn from "../../components/atoms/button/primaryBtn";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSBdCaption01 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption01";
import LectureApi from "../../api/lecture.api";
import { fileUrl } from "../../api/api";
import Empty from "./../../components/molecules/empty";
import { toast } from "react-toastify";
import Loading from "../../components/templates/loading";
import { errorHandler } from "../../util/errorHandler";

const MyPageClassroomLecture = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { memberLectureId, id } = useParams();
  const videoRef = useRef(null);

  // 우클릭 방지
  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          `${route.my_page_classroom_lecture}/${memberLectureId}/${id}`,
        )}`,
        { replace: true },
      );
      return;
    }

    if (
      !Number.isInteger(Number(memberLectureId)) ||
      Number(memberLectureId) <= 0 ||
      !Number.isInteger(Number(id)) ||
      Number(id) <= 0
    ) {
      navigate(route.my_page_classroom, { replace: true });
      return;
    }

    getLectureData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 진행율 관련 ---------- //
  const initialProgressStatus = {
    lastViewedCurriculumId: null,
    curriculumProgressList: [{}],
  };
  const [progressStatus, setProgressStatus] = useState(initialProgressStatus);

  // 진행률 퍼센트 계산 함수
  const calculateProgress = (watchedTime, playTime) => {
    if (!Number.isFinite(playTime) || playTime <= 0) return 0;
    return Math.max(
      0,
      Math.min(100, Math.round((watchedTime / playTime) * 100)),
    );
  };

  // 전체 진행률 계산
  const calculateOverallProgress = (curriculumList) => {
    if (!Array.isArray(curriculumList) || curriculumList.length === 0) return 0;

    const totalProgress = curriculumList.reduce(
      (sum, item) => sum + Number(item.progress || 0),
      0,
    );
    return Math.round(totalProgress / curriculumList.length);
  };

  // 진도율 서버 업데이트
  const updateProgress = async (obj) => {
    try {
      const target = obj || progressStatus;
      if (!Array.isArray(target.curriculumProgressList)) return;

      const data = {
        progressStatus: JSON.stringify(target),
        progressPercent: calculateOverallProgress(
          target.curriculumProgressList,
        ),
      };
      await LectureApi.updateMember(memberLectureId, data);
    } catch (error) {
      console.error("진도율 업데이트 실패:", error);
    }
  };

  // 진행률 업데이트 함수
  const handleTimeUpdate = (curriculumId, currentTime, duration) => {
    const updatedList = () => {
      const updatedList = progressStatus.curriculumProgressList.map((item) =>
        item.curriculumId === curriculumId
          ? {
              ...item,
              watchedTime: Math.floor(currentTime),
              progress:
                calculateProgress(currentTime, duration) >= item.progress
                  ? calculateProgress(currentTime, duration)
                  : item.progress,
            }
          : item,
      );

      return { ...progressStatus, curriculumProgressList: updatedList };
    };

    const data = updatedList();

    setProgressStatus(data);

    updateProgress(data);
  };

  // 동영상 종료 시 진행률 100% 설정
  const handleVideoEnded = (curriculumId) => {
    const updatedList = () => {
      const updatedList = progressStatus.curriculumProgressList.map((item) =>
        item.curriculumId === curriculumId
          ? { ...item, watchedTime: item.playTime, progress: 100 }
          : item,
      );

      return { ...progressStatus, curriculumProgressList: updatedList };
    };

    const data = updatedList();

    setProgressStatus(data);

    updateProgress(data);
  };

  // ---------- 강의 데이터 가져오기 ---------- //
  const [lectureData, setLectureData] = useState({});
  const [selectedCurriculum, setSelectedCurriculum] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  //삭제된 강의 고려 안했을 때 데이터 불러오기 코드 (과거)
  // const getLectureData = async () => {
  //   try {
  //     const lectureResponse = (
  //       await LectureApi.getMemberDetail(memberLectureId)
  //     ).data.data.content;

  //     setLectureData(lectureResponse);

  //     const data = {
  //       page: 1,
  //       size: 0,
  //       orderBy: "ASC",
  //       lectureVideoId: id,
  //     };

  //     const curriculumResponse = (await LectureApi.getCurriculumList(data)).data
  //       .data.content;

  //     const progressStatusString = lectureResponse.progressStatus;

  //     let parsedProgressStatus = { curriculumProgressList: [] };

  //     if (progressStatusString) {
  //       try {
  //         const fixedProgressStatusString = progressStatusString
  //           .replace(/(\w+):/g, '"$1":') // 속성 이름을 쌍따옴표로 감싸기
  //           .replace(/'/g, '"'); // 단일 따옴표를 쌍따옴표로 변경

  //         parsedProgressStatus = JSON.parse(fixedProgressStatusString);
  //       } catch (error) {
  //         console.error(
  //           "progressStatus 파싱 에러:",
  //           error,
  //           progressStatusString
  //         );
  //       }
  //     }

  //     const initialProgressList = curriculumResponse.map((curriculum) => {
  //       const existingProgress =
  //         parsedProgressStatus.curriculumProgressList?.find(
  //           (item) => item.curriculumId === curriculum.id
  //         );

  //       return {
  //         curriculumId: curriculum.id,
  //         title: curriculum.title,
  //         playTime: curriculum.playTime,
  //         watchedTime: existingProgress?.watchedTime || 0,
  //         progress: existingProgress?.progress || 0,
  //         isSelected: false, // 선택 상태 초기화
  //         content: curriculum.content, // 상세 내용
  //       };
  //     });

  //     const lastViewedCurriculumId =
  //       parsedProgressStatus.lastViewedCurriculumId ||
  //       curriculumResponse[0]?.id;

  //     const updatedProgressList = initialProgressList.map((item) => ({
  //       ...item,
  //       isSelected: item.curriculumId === lastViewedCurriculumId,
  //     }));

  //     setProgressStatus({
  //       lastViewedCurriculumId,
  //       curriculumProgressList: updatedProgressList,
  //     });

  //     if (lastViewedCurriculumId) {
  //       const selectedCurriculum = await getCurriculumData(
  //         lastViewedCurriculumId
  //       );
  //       setSelectedCurriculum(selectedCurriculum);
  //     }

  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const getLectureData = async () => {
    try {
      setIsLoading(true);
      const lectureResponse = (
        await LectureApi.getMemberDetail(memberLectureId)
      ).data.data.content;

      if (
        !lectureResponse?.lectureVideoFlag ||
        lectureResponse?.lecture?.id !== Number(id)
      ) {
        toast("올바른 강의 정보가 아닙니다.");
        navigate(route.my_page_classroom, { replace: true });
        return;
      }

      setLectureData(lectureResponse);

      const data = {
        page: 1,
        size: 0,
        orderBy: "ASC",
        lectureVideoId: lectureResponse.lecture.id,
      };

      const curriculumResponse =
        (await LectureApi.getCurriculumList(data)).data.data.content ?? [];
      const progressStatusString = lectureResponse.progressStatus;
      let parsedProgressStatus = { curriculumProgressList: [] };

      if (progressStatusString) {
        try {
          const fixedProgressStatusString = progressStatusString
            .replace(/(\w+):/g, '"$1":')
            .replace(/'/g, '"');
          parsedProgressStatus = JSON.parse(fixedProgressStatusString);
          if (!Array.isArray(parsedProgressStatus?.curriculumProgressList)) {
            parsedProgressStatus = { curriculumProgressList: [] };
          }
        } catch (error) {
          console.error(
            "progressStatus 파싱 에러:",
            error,
            progressStatusString,
          );
        }
      }

      const initialProgressList = curriculumResponse.map((curriculum) => {
        const existingProgress =
          parsedProgressStatus.curriculumProgressList?.find(
            (item) => item.curriculumId === curriculum.id,
          );
        return {
          curriculumId: curriculum.id,
          title: curriculum.title,
          playTime: curriculum.playTime,
          watchedTime: Math.max(0, Number(existingProgress?.watchedTime) || 0),
          progress: Math.max(
            0,
            Math.min(100, Number(existingProgress?.progress) || 0),
          ),
          isSelected: false,
          content: curriculum.content,
        };
      });

      // 기존에 저장된 lastViewedCurriculumId가 없다면 첫 커리큘럼 아이디 사용
      const lastViewedCurriculumId =
        parsedProgressStatus.lastViewedCurriculumId ||
        curriculumResponse[0]?.id;

      const updatedProgressList = initialProgressList.map((item) => ({
        ...item,
        isSelected: item.curriculumId === lastViewedCurriculumId,
      }));

      setProgressStatus({
        lastViewedCurriculumId,
        curriculumProgressList: updatedProgressList,
      });

      // lastViewedCurriculumId로 커리큘럼 데이터 가져오기 시도
      if (!lastViewedCurriculumId) return;

      try {
        const selectedCurriculum = await getCurriculumData(
          lastViewedCurriculumId,
        );
        setSelectedCurriculum(selectedCurriculum);
      } catch (error) {
        // 400 에러일 경우 초기 상태로 진도율 재설정
        if (error?.response?.data?.statusCode === 400) {
          toast.error(error?.response?.data?.message);

          console.error(
            "400 에러 발생: 잘못된 lastViewedCurriculumId. 초기 상태로 재설정합니다.",
          );
          const initialId = curriculumResponse[0]?.id;
          const updatedProgressList = initialProgressList.map((item) => ({
            ...item,
            isSelected: item.curriculumId === initialId,
          }));
          const newProgressStatus = {
            lastViewedCurriculumId: initialId,
            curriculumProgressList: updatedProgressList,
          };
          setProgressStatus(newProgressStatus);
          updateProgress(newProgressStatus);
          // 초기 커리큘럼 데이터 재조회
          const selectedCurriculum = await getCurriculumData(initialId);
          setSelectedCurriculum(selectedCurriculum);
        } else {
          throw error;
        }
      }
    } catch (error) {
      errorHandler(error);
      navigate(route.my_page_classroom, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- 커리큘럼 단일 데이터 가져오기 ---------- //
  // const getCurriculumData = async (id) => {
  //   try {
  //     const response = (await LectureApi.getCurriculumDetail(id)).data.data
  //       .content;

  //     return response;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const getCurriculumData = async (id) => {
    try {
      const response = (await LectureApi.getCurriculumDetail(id)).data.data
        .content;
      return response;
    } catch (error) {
      // 여기서는 toast.error를 호출하지 않고, 에러만 throw
      throw error;
    }
  };

  const selectCurriculum = async (item) => {
    try {
      const response = await getCurriculumData(item.curriculumId);
      setSelectedCurriculum(response);

      const updatedProgressList = progressStatus.curriculumProgressList.map(
        (curriculum) => ({
          ...curriculum,
          isSelected: curriculum.curriculumId === item.curriculumId,
        }),
      );

      const nextProgressStatus = {
        curriculumProgressList: updatedProgressList,
        lastViewedCurriculumId: item.curriculumId,
      };

      setProgressStatus(nextProgressStatus);
      await updateProgress(nextProgressStatus);

      if (selectedCurriculum.id === item.curriculumId) {
        videoRef.current?.play();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <HeaderContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <HeaderCategoryCircle>
                <LSBdBody01 style={{ marginTop: 2, color: "#fff" }}>
                  {lectureData?.lecture?.lectureCategory
                    ?.lectureCategoryType === "FINANCE_STUDY"
                    ? "금융 스터디"
                    : "영상 강의"}
                </LSBdBody01>
              </HeaderCategoryCircle>
              <HeaderCategoryCircle isSub={true}>
                <LSBdBody01 style={{ marginTop: 2, color: "#5050FF" }}>
                  {lectureData?.lecture?.lectureCategory?.title || ""}
                </LSBdBody01>
              </HeaderCategoryCircle>
            </div>
            <LSRgDisplay03
              style={{
                width: 621,
                overflowWrap: "break-word",
                color: "#000",
                margin: "5px 0px 0px 16px",
              }}
            >
              {lectureData?.lecture?.title || ""}
            </LSRgDisplay03>
          </HeaderContainer>

          {/* 본문 영역 */}
          <ContentContainer>
            {selectedCurriculum?.videoServerFileName ? (
              <video
                key={selectedCurriculum?.videoServerFileName} // key 속성으로 선택된 커리큘럼 변경 시 강제 리랜더링
                ref={videoRef}
                onTimeUpdate={(e) => {
                  // const currentTime = e.target.currentTime;
                  // const duration = e.target.duration;
                  // 매 초마다 동영상 시간 업데이트
                  // handleTimeUpdate(
                  //   selectedCurriculum.id,
                  //   currentTime,
                  //   duration
                  // );
                }}
                onLoadedMetadata={(e) => {
                  // 메타데이터 로드 후 playtime으로 이동
                  const videoElement = e.target;

                  const curriculumProgress =
                    progressStatus.curriculumProgressList.find(
                      (item) => item.curriculumId === selectedCurriculum.id,
                    );

                  const startTime = curriculumProgress?.watchedTime || 0;

                  if (startTime > 0) {
                    videoElement.currentTime = startTime;
                  }
                }}
                onPause={(e) => {
                  const currentTime = e.target.currentTime;
                  const duration = e.target.duration;

                  // 동영상 일시정지 시 진행률 저장
                  handleTimeUpdate(
                    selectedCurriculum.id,
                    currentTime,
                    duration,
                  );
                }}
                onEnded={() => handleVideoEnded(selectedCurriculum.id)}
                style={{
                  width: 790,
                  height: 444,
                  borderRadius: 20,
                  objectFit: "cover",
                }}
                post={""}
                controls
                controlsList="nodownload" // 다운로드 버튼 비활성화
                disablePictureInPicture // PiP 모드 비활성화
              >
                <source
                  src={
                    selectedCurriculum?.videoServerFileName
                      ? `${fileUrl}/${selectedCurriculum?.videoServerFileName}`
                      : ""
                  }
                  type={
                    selectedCurriculum?.videoServerFileName
                      ? `video/${selectedCurriculum.videoServerFileName
                          .split(".")
                          .pop()}`
                      : "video/mp4"
                  }
                />
              </video>
            ) : (
              <div
                style={{
                  width: 790,
                  height: 444,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Empty title="표시할 영상이 없습니다." />
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CurriculumContainer>
                <CurriculumHeaderWrapper>
                  <CurriculumLeftWrapper style={{ padding: "0px 10px" }}>
                    <LSRgH1HeadLine style={{ color: "#000" }}>
                      강의명
                    </LSRgH1HeadLine>
                  </CurriculumLeftWrapper>
                  <CurriculumRightWrapper style={{ padding: "0px 15px" }}>
                    <LSRgH1HeadLine style={{ color: "#000" }}>
                      진도율
                    </LSRgH1HeadLine>
                  </CurriculumRightWrapper>
                </CurriculumHeaderWrapper>

                <CurriculumBodyWrapper>
                  {progressStatus.curriculumProgressList?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        height: "fit-content",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: item.isSelected ? "#F6F6FF" : "",
                      }}
                    >
                      <CurriculumBodyTextWrapper>
                        <CurriculumLeftWrapper
                          style={{
                            minHeight: 54,
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 10,
                            cursor: "pointer",
                          }}
                          onClick={() => selectCurriculum(item)}
                        >
                          <LSRgH1HeadLine style={{ color: "#101113" }}>
                            {item?.title || ""}
                          </LSRgH1HeadLine>
                        </CurriculumLeftWrapper>
                        <CurriculumRightWrapper style={{ minHeight: 54 }}>
                          <LSBdH1HeadLine
                            style={{
                              color:
                                Number(item.progress) === 0 &&
                                selectedCurriculum.id !== item.curriculumId
                                  ? "#a4a8b1"
                                  : "#5050FF",
                            }}
                          >
                            {item.progress || 0}%
                          </LSBdH1HeadLine>
                        </CurriculumRightWrapper>
                      </CurriculumBodyTextWrapper>
                      {item.isSelected && (
                        <LSRgBody01
                          style={{
                            padding: "0px 10px 16px 10px",
                            color: "#101113",
                          }}
                        >
                          {item?.content || ""}
                        </LSRgBody01>
                      )}
                    </div>
                  ))}
                </CurriculumBodyWrapper>
              </CurriculumContainer>
              <PrimaryBtn
                style={{
                  marginTop: 16,
                }}
                btnText="나의 강의실 바로가기"
                onClick={() => {
                  navigate(route.my_page_classroom);
                }}
              />
            </div>
          </ContentContainer>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <>
          {selectedCurriculum?.videoServerFileName ? (
            <video
              key={selectedCurriculum?.videoServerFileName} // key 속성으로 선택된 커리큘럼 변경 시 강제 리랜더링
              ref={videoRef}
              onTimeUpdate={(e) => {
                // const currentTime = e.target.currentTime;
                // const duration = e.target.duration;
                // 매 초마다 동영상 시간 업데이트
                // handleTimeUpdate(
                //   selectedCurriculum.id,
                //   currentTime,
                //   duration
                // );
              }}
              onLoadedMetadata={(e) => {
                // 메타데이터 로드 후 playtime으로 이동
                const videoElement = e.target;

                const curriculumProgress =
                  progressStatus.curriculumProgressList.find(
                    (item) => item.curriculumId === selectedCurriculum.id,
                  );

                const startTime = curriculumProgress?.watchedTime || 0;

                if (startTime > 0) {
                  videoElement.currentTime = startTime;
                }
              }}
              onPause={(e) => {
                const currentTime = e.target.currentTime;
                const duration = e.target.duration;

                // 동영상 일시정지 시 진행률 저장
                handleTimeUpdate(selectedCurriculum.id, currentTime, duration);
              }}
              onEnded={() => handleVideoEnded(selectedCurriculum.id)}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
              post={""}
              controls
              controlsList="nodownload" // 다운로드 버튼 비활성화
              disablePictureInPicture // PiP 모드 비활성화
            >
              <source
                src={
                  selectedCurriculum?.videoServerFileName
                    ? `${fileUrl}/${selectedCurriculum?.videoServerFileName}`
                    : ""
                }
                type={
                  selectedCurriculum?.videoServerFileName
                    ? `video/${selectedCurriculum.videoServerFileName
                        .split(".")
                        .pop()}`
                    : "video/mp4"
                }
              />
            </video>
          ) : (
            <div
              style={{
                width: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Empty title="표시할 영상이 없습니다." />
            </div>
          )}
          <MOContainer>
            <ContentContainer $isSmall={isSmall}>
              <HeaderContainer $isSmall={isSmall}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  <HeaderCategoryCircle $isSmall={isSmall}>
                    <LSBdCaption01 style={{ marginTop: 2, color: "#fff" }}>
                      {lectureData?.lecture?.lectureCategory
                        ?.lectureCategoryType === "FINANCE_STUDY"
                        ? "금융 스터디"
                        : "영상 강의"}
                    </LSBdCaption01>
                  </HeaderCategoryCircle>
                  <HeaderCategoryCircle $isSmall={isSmall} isSub={true}>
                    <LSBdCaption01 style={{ marginTop: 2, color: "#5050FF" }}>
                      {lectureData?.lecture?.lectureCategory?.title || ""}
                    </LSBdCaption01>
                  </HeaderCategoryCircle>
                </div>
                <LSRgH1HeadLine
                  style={{
                    width: 335,
                    overflowWrap: "break-word",
                  }}
                >
                  {lectureData?.lecture?.title || ""}
                </LSRgH1HeadLine>
              </HeaderContainer>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CurriculumContainer $isSmall={isSmall}>
                  <CurriculumHeaderWrapper>
                    <CurriculumLeftWrapper style={{ padding: "0px 10px" }}>
                      <LSRgH1HeadLine style={{ color: "#000" }}>
                        강의명
                      </LSRgH1HeadLine>
                    </CurriculumLeftWrapper>
                    <CurriculumRightWrapper style={{ padding: "0px 15px" }}>
                      <LSRgH1HeadLine style={{ color: "#000" }}>
                        진도율
                      </LSRgH1HeadLine>
                    </CurriculumRightWrapper>
                  </CurriculumHeaderWrapper>

                  <CurriculumBodyWrapper>
                    {progressStatus.curriculumProgressList.map(
                      (item, index) => (
                        <div
                          key={index}
                          style={{
                            width: "100%",
                            height: "fit-content",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: item.isSelected ? "#F6F6FF" : "",
                          }}
                        >
                          <CurriculumBodyTextWrapper>
                            <CurriculumLeftWrapper
                              style={{ minHeight: 54, cursor: "pointer" }}
                              onClick={() => selectCurriculum(item)}
                            >
                              <LSRgH1HeadLine style={{ color: "#101113" }}>
                                {item?.title || ""}
                              </LSRgH1HeadLine>
                            </CurriculumLeftWrapper>
                            <CurriculumRightWrapper style={{ minHeight: 54 }}>
                              <LSBdH1HeadLine
                                style={{
                                  color:
                                    Number(item.progress) === 0 &&
                                    selectedCurriculum.id !== item.curriculumId
                                      ? "#a4a8b1"
                                      : "#5050FF",
                                }}
                              >
                                {item.progress || 0}%
                              </LSBdH1HeadLine>
                            </CurriculumRightWrapper>
                          </CurriculumBodyTextWrapper>
                          {item.isSelected && (
                            <LSRgBody01
                              style={{
                                padding: "0px 10px 16px 10px",
                                color: "#101113",
                              }}
                            >
                              {item?.content || ""}
                            </LSRgBody01>
                          )}
                        </div>
                      ),
                    )}
                  </CurriculumBodyWrapper>
                </CurriculumContainer>
                <PrimaryBtn
                  style={{
                    width: 335,
                  }}
                  btnText="나의 강의실 바로가기"
                  onClick={() => {
                    navigate(route.my_page_classroom);
                  }}
                />
              </div>
            </ContentContainer>
          </MOContainer>
        </>
      )}
    </HomeSection>
  );
};

export default MyPageClassroomLecture;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const HeaderContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  align-items: ${(props) => (props.$isSmall ? "flex-start" : "center")};
  gap: ${(props) => (props.$isSmall ? "10px" : "0px")};
  width: 100%;
  min-height: ${(props) => (props.$isSmall ? "56px" : "45px")};
  margin: ${(props) => (props.$isSmall ? "20px 0px" : "0px")};
`;

const HeaderCategoryCircle = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: ${(props) => (props.$isSmall ? "24px" : "32px")};
  padding: ${(props) => (props.$isSmall ? "6px 12px" : "6px 14px;")};
  border: ${(props) => (props.isSub ? "1px solid #5050FF" : "none")};
  border-radius: 30px;
  background-color: ${(props) => (props.isSub ? "transparent" : "#5050FF")};
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "100%")};
  height: fit-content;
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  height: fit-content;
  gap: ${(props) => (props.$isSmall ? "0px" : "30px")};
  margin-top: ${(props) => (props.$isSmall ? "0px" : "20px")};
`;

const CurriculumContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "100%" : "380px")};
  height: fit-content;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin-bottom: ${(props) => (props.$isSmall ? "20px" : "16pxw")};
`;

const CurriculumHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 38px;
  padding-bottom: 16px;
  border-bottom: 1px solid #dbdde0;
  margin-bottom: 16px;
`;

const CurriculumLeftWrapper = styled.div.attrs((props) => {})`
  width: 268px;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const CurriculumRightWrapper = styled.div.attrs((props) => {})`
  width: 72px;
  padding: 16px 15px;
  display: flex;
  align-items: center;
`;

const CurriculumBodyWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;

const CurriculumBodyTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: fit-content;
`;
